import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { httpinstance,httpinstancefile } from "../../../axios/api"


export const get_vehicle_types = createAsyncThunk('get_vehicle_types', async (queryParams)=>{
    try{
        const url = `vehicle-types${queryParams}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})
export const delete_vehicle = createAsyncThunk('delete_vehicle', async (id)=>{
    try{
        const url = `vehicle-types/${id}`
        const response = await httpinstance.delete(url)
        return response
    }catch (err){
        return err.response
    }
})

const initialState = {
    data:{},
    loading:false,
}

const rate_managementSlice = createSlice({
    name : 'vehicle_management',
    initialState,
})
export default rate_managementSlice.reducer